import './App.css';
import {Routes,Route} from 'react-router-dom';
import 'animate.css';
import './chartConfig';
import Home from './Pages/Home';
import 'react-toastify/dist/ReactToastify.css';
import NotFoundPage from './Pages/NotFoundPage';
import { UserProvider } from './contexts/UserContext';
import Profil from './Pages/Profil';
import ModifierProfil from './Pages/ModifierProfil';
import Newsletter from './Pages/Newsletter';
import Accueil from './Pages/Accueil';
import Administrator from './Pages/Admin/Administrator';
import Tracabilite from './Pages/Statistiques/Tracabilite';
import StudentDashboard from './Pages/Etudiant/StudentDashboard';
import StudentProfile from './Pages/Etudiant/StudentProfile';
import ProfDashboard from './Pages/Prof/ProfDashboard';
import ProfProfile from './Pages/Prof/ProfProfile';
import AdminDashboard from './Pages/Admin/AdminDashboard';
import TeachersPage from './Pages/Admin/TeachersPage';
import DetailTeacher from './Pages/Admin/DetailTeacher';
import Courses from './Pages/Courses/Courses';
import Exams from './Pages/Exam/Exams';
import Classes from './Pages/Classes/Classes';
import Profile from './Pages/Admin/Profile';
import EmploiDuTemps from './Pages/Emploi/EmploiDuTemps';
import Student from './Pages/Admin/Student';
import Notifications from './Pages/Notifications/Notifications';
import StudentDetail from './Pages/Admin/StudentDetail';
import Rooms from './Pages/Salles/Rooms';
import Bulletins from './Pages/Bulletins/Bulletins';




export default function App() {
  return (
    <UserProvider>
    <Routes>
    <Route path='/' element={ <Home/> }/>
       <Route path='/Accueil' element={ <Accueil/> }/>
   <Route path="/actions" element={<Tracabilite />} />
     <Route path="/Mon--profil" element={<Profil/>} />
     <Route path="/modifier-profil/:id" element={<ModifierProfil />} />
    <Route path="/newsletter" element={<Newsletter />} />
    <Route path="*" element={<NotFoundPage />} />
    <Route path="/administrator" element={<Administrator />} />
    <Route path="/studentDashboard" element={<StudentDashboard />} />
    <Route path="/studentProfile" element={<StudentProfile />} />
    <Route path="/profDashboard" element={<ProfDashboard />} />
    <Route path="/profProfile" element={<ProfProfile />} />
    <Route path="/AdminDashboard" element={<AdminDashboard />} />
    <Route path="/TeachersPage" element={<TeachersPage />} />
    <Route path="/teachers/:teacherId" element={<DetailTeacher />} />
    <Route path="/courses" element={<Courses />} />
    <Route path="/exams" element={<Exams />} />
    <Route path="/classes" element={<Classes />} />
      <Route path="/profile" element={<Profile />} />
    <Route path="/emploi/temps" element={<EmploiDuTemps />} />
    <Route path="/student" element={<Student />} />
    <Route path="/notifications" element={<Notifications />} />
    <Route path="/student/:id" element={<StudentDetail />} />
    <Route path="/rooms" element={<Rooms />} />
        <Route path="/bulletins" element={<Bulletins />} />
       
  </Routes>
 
  </UserProvider>
  );
}

